import {
    FormControlLabel,
    RadioGroup,
    Radio,
    RadioGroupProps,
    FormHelperText,
    RadioProps,
    styled,
} from '@mui/material';
import { common } from '@mui/material/colors';
import { colors } from 'common/constants';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

type BaseScoreProps = RadioGroupProps & {
    name: string;
    options: { label: string; value: string | number }[];
};

const BaseScore: React.FC<BaseScoreProps> = ({ name, options, ...props }) => {
    const { control } = useFormContext();
    return (
        <Controller
            control={control}
            name={name}
            render={({ field, fieldState }) => (
                <>
                    <RadioGroup {...field} {...props}>
                        {options.map((option) => (
                            <FormControlLabel
                                sx={{
                                    margin: 0,
                                    gap: '5px',
                                }}
                                key={option.value}
                                value={option.value}
                                control={<BpRadio />}
                                label={''}
                            />
                        ))}
                    </RadioGroup>
                    <FormHelperText
                        sx={{
                            fontSize: '14px',
                            marginLeft: 0,
                            color: `${colors.textError} !important`,
                            fontWeight: '400',
                        }}
                    >
                        {fieldState.error?.message}
                    </FormHelperText>
                </>
            )}
        />
    );
};
function BpRadio(props: RadioProps) {
    return (
        <Radio
            disableRipple
            color="default"
            checkedIcon={<BpCheckedIcon label={String(props.value)} />}
            icon={<BpIcon label={String(props.value)} />}
            sx={{ padding: 0 }}
            {...props}
        />
    );
}
const BpIcon = styled('span')<{ label: string }>(({ label, theme }) => ({
    width: 77,
    height: 77,
    boxShadow:
        'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: common.white,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: '10px',
    [theme.breakpoints.up('sm')]: {
        width: 40,
        height: 40,
    },
    [theme.breakpoints.up('md')]: {
        width: 50,
        height: 50,
    },
    [theme.breakpoints.up('lg')]: {
        width: 77,
        height: 77,
    },
    [theme.breakpoints.up('xl')]: {
        width: 77,
        height: 77,
    },

    '&::before': {
        content: `"${label}"`,
        color: theme.palette.primary.main,
        fontSize: '28px',
        [theme.breakpoints.up('sm')]: {
            fontSize: '1.2rem',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '1.5rem',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '2rem',
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '2rem',
        },
    },
    '.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2,
    },
    'input:hover ~ &': {
        backgroundColor: '#ebf1f5',
    },
    'input:disabled ~ &': {
        boxShadow: 'none',
        background: 'rgba(206,217,224,.5)',
    },
}));

const BpCheckedIcon = styled(BpIcon)<{ label: string }>(({ label }) => ({
    backgroundColor: colors.main,
    backgroundImage:
        'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&::before': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        content: `"${label}"`,
        color: common.white,
    },
    'input:hover ~ &': {
        backgroundColor: colors.main,
    },
}));

export default BaseScore;
